<div class="page_nav">
  <svg class="page_nav__icon">
    <use xlink:href="images/sprites5.svg#icon-chevron-left"></use>
  </svg>
  @for (item of itemsArray; track $index) {
  <div class="page_number page_number--active">1</div>
  }
  <svg class="page_nav__icon">
    <use xlink:href="images/sprites5.svg#icon-chevron-right"></use>
  </svg>
</div>

<div class="white_space"></div>
